import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/lib/customer-validators';
import { AccountService } from 'src/app/services/account.service';
import { Account } from 'src/app/models/account';
import { SubscriptionService } from '../../services/subscription.service';
import { tap } from '../../../../node_modules/rxjs/operators';
import { UserSubscription } from '../../models/userSubscription';
import {MatDialog} from '@angular/material/dialog';
import { CancelSubscriptionComponent } from '../../components/modals/cancel-subscription/cancel-subscription.component';
import { Practice } from '../../models/practice';
import { PracticeService } from 'src/app/services/practice.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  public practice: Practice = new Practice();
  public accountForm: FormGroup;
  public passwordForm: FormGroup;
  public account: Account;
  public errors = [];
  public passwordErrors =[];
  public accountUpdated = false;
  public passwordUpdated = false;
  public savingAccount = false;
  public savingPassword = false;
  public subscriptions: UserSubscription[];
  public loading: boolean = true;
  public roles=[];
  public loadingPractice:boolean=true;

  constructor(public dialog: MatDialog, private accountService: AccountService, private subscriptionService: SubscriptionService, private practiceService: PracticeService) {
    this.account = this.accountService.getLocalAccount();
    this.getSubscriptions();
    this.accountForm = new FormGroup({
      'email': new FormControl(this.account.email, [
        Validators.email,
        Validators.required
      ]),
      'first_name': new FormControl(this.account.first_name, Validators.required),
      'last_name': new FormControl(this.account.last_name, Validators.required),
      'required_points': new FormControl((this.account.required_points/60), Validators.required),
      'type': new FormControl(this.account.type, Validators.required)
    });

    this.passwordForm = new FormGroup({
      'current_password': new FormControl(null, [Validators.required]),
      'password': new FormControl(null, [Validators.required,Validators.minLength(8)]),
      'password_confirmation': new FormControl(null, Validators.required),
    },{
      validators: CustomValidators.MatchPassword
    });
  }

  ngOnInit() {
    this.getUserRoles();
    this.getMyPractice();
  }

  getMyPractice(){
    this.practiceService.getMyPractice().subscribe(practice=>{
      this.practice = practice;
      this.loadingPractice = false;
    },err=>{
      this.loadingPractice = false;
    })
  }

  getUserRoles(){
    this.accountService.getRoles().subscribe(
      res=>{
        this.roles=res;
      }
    );
  }

  getSubscriptions(){
    this.subscriptionService.getUserSubscriptions().pipe(
      tap(()=>{
        this.loading = false;
    })).subscribe(res=>{
      this.subscriptions = res;
      this.fixSubDatesForShittySafari();
    });

  }

  fixSubDatesForShittySafari(){
    this.subscriptions.forEach((sub:any, index)=>{
      this.subscriptions[index].sub_until=this.getDate(sub.sub_until);
      // .replace(/\s/g, 'T')
    });
  }

  getDate(value: any): Date {
    // https://github.com//issues/12334
    return value ? new Date(value.replace(/\s/g, 'T')) : undefined;
  }

  cancelSubscription(subscription_id): void {
    const dialogRef = this.dialog.open(CancelSubscriptionComponent, {
      width: '450px',
      data: {subscription_id: subscription_id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getSubscriptions();
      }
    });
  }

  save(){
    this.errors=[];
    this.accountUpdated = false;
    this.savingAccount = true;
    this.account.first_name = this.accountForm.get('first_name').value;
    this.account.last_name = this.accountForm.get('last_name').value;
    this.account.email = this.accountForm.get('email').value;
    this.account.required_points = this.accountForm.get('required_points').value;
    this.account.type = this.accountForm.get('type').value;

    this.accountService.saveAccount(this.account).subscribe(res=>{
      this.accountUpdated = true;
      this.savingAccount = false;
    },err=>{
      let errorObject = JSON.parse(err.error);
      Object.entries(errorObject).forEach((k, v) =>{
        this.errors.push(k[1][0]);
      });
      this.savingAccount = false;
    })
  }

  savePassword(){
    this.passwordErrors =[];
    this.passwordUpdated = false;
    this.savingPassword = true;
    this.accountService.savePassword(this.passwordForm.get('password').value,this.passwordForm.get('password_confirmation').value, this.passwordForm.get('current_password').value).subscribe(res=>{
      if (res.error) {
        this.passwordErrors.push(res.error);
        this.savingPassword = false;
      } else {
        this.passwordUpdated = true;
        this.passwordForm.reset();
      }
    },err=>{
      this.savingPassword = false;

    })
  }


  getPlanCurrencyDisplay(plan: any, quantity: number): string {
    if (plan.id <= 6) {
      return '£' + (plan.amount / 100 * quantity).toFixed(2);
    }
    const amount = plan.amount * quantity;
    if (plan.name.includes('HKD')) return 'HK$' + amount.toFixed(2);
    if (plan.name.includes('EUR')) return '€' + amount.toFixed(2);
    if (plan.name.includes('USD')) return '$' + amount.toFixed(2);
    if (plan.name.includes('NZD')) return 'NZ$' + amount.toFixed(2);
    if (plan.name.includes('AUD')) return 'AUD$' + amount.toFixed(2);
    if (plan.name.includes('CAD')) return 'C$' + amount.toFixed(2);
    if (plan.name.includes('AED')) return 'AED ' + amount.toFixed(2);
    return amount.toFixed(2);
  }
}
